import { useEffect, useState } from 'react';

/**
 * Determines whether the current device is running iOS.
 *
 * Detects iPhone, iPad, and iPod devices based on the user agent.
 * Returns `false` during server-side rendering.
 */
const useIsIOS = () => {
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    setIsIOS(/iPad|iPhone|iPod/.test(window.navigator.userAgent));
  }, []);

  return isIOS;
};

export default useIsIOS;
